import { useState } from "react";
import { Container } from "@mui/material";
import useStore from "../store/store";
import userService from "../services/user";
import { FormatPhone, Password, Text, Heading, Button } from "../controls";

function AddUser({ setIsOpen, reload }) {
	let [name, setName] = useState("");
	let [phone, setPhone] = useState("");
	let [password, setPassword] = useState("");

	const { token, setErrorMessage, setSuccessMessage, setIsLoading } =
		useStore((state) => state);

	const createUser = () => {
		setIsLoading(true);
		let data = { name, phone: phone.trim(), password };
		userService.create(token, data).then((r) => {
			if (r.error) {
				setErrorMessage(r.error);
				setIsLoading(false);
				return;
			}
			if (r.data) {
				setSuccessMessage("User successfully created");
				setIsOpen(false);
				clearForm();
				reload();
			}
		});
	};

	const clearForm = () => {
		setName("");
		setPhone("");
		setPassword("");
	};

	return (
		<>
			<Container sx={{ overflow: "auto" }}>
				<Heading text="Add User" variant="h6" />
				<Text label="Name" value={name} onChange={setName} />
				<FormatPhone label="Phone" value={phone} onChange={setPhone} />
				<Password
					label="Initial password"
					value={password}
					onChange={setPassword}
				/>
				<Button
					icon={<ion-icon name="add-circle-outline"></ion-icon>}
					onClick={createUser}
					text="Create"
				/>
			</Container>
		</>
	);
}

export default AddUser;
